angular.module('gym.access_control').controller('AccessControlSettingsModalCtrl', ["$scope", "$modalInstance", "settings", function($scope, $modalInstance, settings) {
  $scope.settings = settings;
  $scope.save = function() {
    $scope.settings.rootObjectName = 'gym_brivo_detail';
    return $scope.settings.save().then(function() {
      return $modalInstance.close();
    });
  };
  return $scope.close = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
